<app-tab-grid
  i18n-name
  name="Order Additional Properties"
  [columnDefs]="columnDefs"
  [rowData]="model$ | async"
  [showDelete]="false"
  [showCreate]="false"
  [showExport]="false"
  (edit)="edit($event)"
></app-tab-grid>
